module.exports = __webpack_public_path__ + "static/media/credit-card.2947f4e8.svg";